import { Answer } from '../../redux/Slices/InterviewSlice/types';
import api from '../api';

export const hrApi = api.injectEndpoints({
  endpoints: builder => ({
    hrEndTest: builder.mutation({
      query: userTestId => ({
        url: '/api/hr/user/test/end/test',
        method: 'PUT',
        params: { userTestId }
      })
    }),
    hrGenerateTest: builder.mutation({
      query: () => ({
        url: '/api/hr/test/generate/test',
        method: 'POST'
      })
    }),
    hrSubmitAnswer: builder.mutation({
      query: ({ userTestId, body }: { userTestId: string; body: Answer }) => ({
        url: '/api/hr/user/test/submit/answer',
        method: 'PUT',
        body,
        params: {
          userTestId
        }
      })
    }),
    fetchHRTests: builder.query<
      any,
      { size: number; page: number; userId: string }
    >({
      query: ({ size, page, userId }) => ({
        url: '/api/hr/user/test/user/tests',
        method: 'GET',
        params: { page, size, userId }
      })
    }),
    fetchHRTestById: builder.query({
      query: ({ userTestId, userId }) => ({
        url: '/api/hr/user/test/user/test',
        method: 'GET',
        params: { userTestId, userId }
      })
    })
  })
});

export const {
  useHrEndTestMutation,
  useHrGenerateTestMutation,
  useHrSubmitAnswerMutation,
  useFetchHRTestsQuery,
  useLazyFetchHRTestsQuery,
  useLazyFetchHRTestByIdQuery
} = hrApi;
